/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

/*
  Convenience function for building DOM elements, e.g:

  h("div", { "class": "test", $click: evt => console.log('hi') }, [
    h("p", "First paragraph"),
    h("img", { src: "test.png" }),
    "Some text afterwards")
  ])

  Parameters:
    tag - tag name of element create
    attrs - optional - attributes and event handlers, event names should be prefixed with '$'
    content - optional - either string, DOM node or an array containing strings/DOM nodes to be added as children of the element

  Returns a single DOM element
*/
function isContent(x) {
    return typeof x === 'string' || x instanceof Node || 'forEach' in x;
}

function h(tag, attrs, content) {
    var el = document.createElement(tag);

    if(attrs !== undefined && isContent(attrs)) {
        content = attrs;
        attrs = undefined;
    }

    if(content !== undefined) {
        if(typeof content === 'string') {
            el.appendChild(document.createTextNode(content));
        } else if(content instanceof Node) {
            el.appendChild(content);
        } else if('forEach' in content) {
            content.forEach(child => {
                if(typeof child === 'string') {
                    el.appendChild(document.createTextNode(child));
                } else if(child) {
                    el.appendChild(child);
                }
            });
        }
    }

    for(var key in attrs || {}) {
        if(key[0] == '$') {
            el.addEventListener(key.substring(1), attrs[key]);
        } else {
            el.setAttribute(key, attrs[key]);
        }
    }

    return el;
}

export default h;
